// import axios from 'axios';
import api from '@/api';
import {
//
} from './mutation-types';

export default {
    // eslint-disable-next-line no-unused-vars
    sendEmail ({ commit }, inquery) {
        console.log('action! inquery', inquery);        
        // return api.post('/inquery/sendEmail', inquery);
        // return api.post('/v1/ContactUsByEmail', inquery);

        // return api.post('/inquery/sendEmail', inquery, {
        //     headers: {
        //         'Accept-Language': inquery.lang
        //     },
        // });

        // 테스트용으로 서버 응답을 모의로 만듦
        // return new Promise((resolve) => {
        //     const mockResponse = {
        //         data: {
        //             result: 'Failed',  // 'Requested'가 아닌 값을 설정하여 테스트
        //         },
        //     };

        //     resolve(mockResponse);  // 모의 응답을 resolve
        // });

        // https://test.lecos.co.kr/api/v1/ContactUsByEmail
        // /api/v1/ContactUsByEmail
        return api.post('/api/v1/ContactUsByEmail', inquery, {
            headers: {
                'Accept-Language': inquery.lang
            },
        });

        // return api.put('/api/v1.0/learningSpace/productCancellation', null, {
        //     headers: {
        //         product_id: payload.productId,
        //         product_status: payload.productStatus,
        //     },
        // });
    },
};
